import { academiaMejiasApi } from "../academiaMejiasApi";

interface loginUserParams {
    email: string;
    password: string;

}

export const registerNormalUser = async (datos: any) => {
    console.log("datos en el provider que hace la peticion");

    console.log(datos);

    try {
        // Haces la llamada POST a tu API para registrar al usuario
        const { data } = await academiaMejiasApi.post('/auth/register/student', datos);
        // Suponiendo que tu API responde con { ok: true, user: userData } cuando es exitoso
        return { ok: true, user: data.user, token: data.token };
    } catch (error: any) {
        // Aquí capturas el error y retornas un objeto indicando el fallo
        console.log(error.response.data);
        return {
            ok: false,
            errorMessage: error.response.data
        };
    }
}


export const loginUserAdmin = async ({ email, password }: loginUserParams) => {
    try {
        // Haces la llamada POST a tu API para iniciar sesión
        const { data } = await academiaMejiasApi.post('/auth/login/admin', { email, password });
        // Suponiendo que tu API responde con { ok: true, user: userData } cuando es exitoso

        return { ok: true, user: data, token: data.token };
    } catch (error: any) {
        // Aquí capturas el error y retornas un objeto indicando el fallo
        console.log(error);
        return {
            ok: false,
            errorMessage: error.response.data
        };
    }
}
export const loginUser = async ({ email, password }: loginUserParams) => {
    try {
        // Haces la llamada POST a tu API para iniciar sesión
        const { data } = await academiaMejiasApi.post('/auth/login', { email, password });
        // Suponiendo que tu API responde con { ok: true, user: userData } cuando es exitoso
        console.log(data);

        return { ok: true, user: data.user, token: data.token };
    } catch (error: any) {
        // Aquí capturas el error y retornas un objeto indicando el fallo
        console.log(error.response.data);
        return {
            ok: false,
            errorMessage: error.response.data
        };
    }
}


export const getRoles = async (token: string) => {
    try {
        // Haces la llamada POST a tu API para iniciar sesión
        const { data } = await academiaMejiasApi.post('/auth/check-roles',
            {}, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return { ok: true, roles: data };
    } catch (error: any) {
        // Aquí capturas el error y retornas un objeto indicando el fallo
        console.log(error.response.data);
        return {
            ok: false,
            errorMessage: error.response.data
        };
    }
}





